module.exports = __webpack_public_path__ + "avab.f4569024da4ce71b3fd8.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/avab.woff
// module id = ./src/assets/webfonts/avab.woff
// module chunks = styles